import { deleteExtraResourceProject, deleteRequestHoursExtra, deleteResponseUpdateHours } from "../../../../config";
import { MessageAnt } from "../../../../redux/slices/ui/uiAction";
import { MessageType } from "../../../../types/messageType";
import { typeForDetailsProyect } from "../../../../types/typeModalDetailsProject";

const deleteExtraTime = async ({ form: { extraTimeId } }) => {
    const { status } = await deleteRequestHoursExtra(extraTimeId);
    if (status > 0) {
        MessageAnt(MessageType.error, `Error al eliminar tiempo extra`);
        return false;
    }
    return true;
};

const deleteExtraResource = async ({ form: { extraResourceId } }) => {
    const { status } = await deleteExtraResourceProject(extraResourceId);
    if (status > 0) {
        MessageAnt(MessageType.error, `Error al eliminar recurso extra`);
        return false;
    }
    return true;
};

const deleteAdjustmentOfHours = async ({ form: { adjustmentOfHoursId }, extraData: { idSpace } }) => {
    const { status } = await deleteResponseUpdateHours({ backupId: adjustmentOfHoursId, spaceId: idSpace });
    if (status > 0) {
        MessageAnt(MessageType.error, `Error al eliminar ajuste de horas`);
        return false;
    }
    return true;
};

export const handlersDeleteRow = {
    [typeForDetailsProyect.deleteExtraResoruce]: deleteExtraResource,
    [typeForDetailsProyect.deleteExtraTime]: deleteExtraTime,
    [typeForDetailsProyect.deleteAdjustmentOfHours]: deleteAdjustmentOfHours,
};